import axiosApiInstance from '../../interceptors/axiosApiInstance';
import {BASE_URL, NETWORK_ERROR} from '../config';
import {setServiceMessage} from '../../helpers/helper';

const CredentialService = {
    newCredential: async function (data) {
        try {
            const response = await axiosApiInstance.post(BASE_URL + '/connection', data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    newCredentialValue: async function (data, id) {
        try {
            const response = await axiosApiInstance.post(BASE_URL + `/connection/${id}/attribute-values`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    updateCredentialValue: async function (data, id) {
        try {
            const response = await axiosApiInstance.put(BASE_URL + `/connection/${id}/attribute-values`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    updateCredential: async function (data, id) {
        try {
            return await axiosApiInstance.post(BASE_URL + `api/v1/connection/${id}/data-attributes`, data);
        } catch (error) {
            return error;
        }
    },
    getCredentialRequest: async function () {
        try {
            const response = await axiosApiInstance.get(BASE_URL + '/connection/request');
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },  // Owner
    deleteCredential: async function (arrayData) {
        try {
            const response = await axiosApiInstance.delete(BASE_URL + `/connection`, {
                data: {
                    ids: arrayData
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },  // Requester
    deleteCredentialRequest: async function (arrayData) {
        try {
            const response = await axiosApiInstance.post(BASE_URL + `/connection/request/delete`, {id: arrayData})
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getCredentials: async function (status) {
        try {
            const queryParam = status ? `?status=${status}` : '';
            const response = await axiosApiInstance.get(BASE_URL + `/connection${queryParam}`);
            return response.data;
        } catch (error) {
            if (error.response) {
                return setServiceMessage(error.response.data, 'CONTENT.CREDENTIAL-TAB.');
            } else {
                return NETWORK_ERROR;
            }
        }
    },
    getPublicCredentials: async function () {
        try {
            const response = await axiosApiInstance.get(BASE_URL + '/connection/public-connection');
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getCredentialByFilter: async function (id) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/connection/getbyid?id=${id}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    postCredentialRequest: async function (data) {
        try {
            const response = await axiosApiInstance.post(BASE_URL + '/connection/request', data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    setCredentialStatus: async function (id, data) {
        try {
            const response = await axiosApiInstance.put(BASE_URL + `/connection/request-approve/${id}`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    editCredential: async function (data) {
        try {
            const response = await axiosApiInstance.put(BASE_URL + '/connection', data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    }
};

export default CredentialService;
